import {
  EntityBarFilterConfig,
  IconBarsThree,
  IconPlay
} from '@sequencehq/core-components'
import { WatchtowerFilterType } from './atoms'

export const WATCHTOWER_FILTER_CONFIGS: ({
  useAutomationsDunning
}: {
  useAutomationsDunning: boolean
}) => EntityBarFilterConfig<WatchtowerFilterType>[] = ({
  useAutomationsDunning
}) => {
  return [
    {
      type: 'status',
      label: 'Status',
      icon: IconBarsThree,
      options: [
        { label: 'In progress', value: 'RUNNING' },
        { label: 'Completed', value: 'COMPLETED' },
        { label: 'Failed', value: 'FAILED' },
        { label: 'Canceled', value: 'TERMINATED' }
      ]
    },
    {
      type: 'trigger',
      label: 'Type',
      icon: IconPlay,
      options: [
        { label: 'Quotes', value: 'QUOTE_REQUIRES_APPROVAL' },
        { label: 'Contract intake', value: 'CONTRACT_UPLOADED' },
        ...(useAutomationsDunning
          ? [{ label: 'Invoice reminders', value: 'INVOICE_SENT' }]
          : [])
      ]
    }
  ]
}
